// Feature flags — build-time constants (import.meta.env is inlined by Vite at build).

// Live Standup board gate. The board ships DARK: its /live + /live/:userId routes and the TopNav
// "Live" entry are hidden until the BFF route (GET /api/surfaces/team/standup/live) is confirmed
// live in prod. Enabled in dev (MSW serves the fixture) and on any deploy that sets
// VITE_LIVE_STANDUP_ENABLED=true (e.g. staging for E2E); off in prod until flipped.
// See .planning/specs/2026-07-06-live-standup-v1-build.md §6 step 5.
export const LIVE_STANDUP_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_LIVE_STANDUP_ENABLED === "true";
